import { OfficeTransferDetail } from "@/type/core/officeTransfer/officeTransfer.types";
import configuration from "@/utils/Config";
import { restDetailsHandler, restPostHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";

const baseUrl = configuration.backendBaseUrl;
const officeTransferUrl = baseUrl + "/ws/fo/officeTransfer";
const officeTransferConfirmUrl = "/confirm";
const officeTransferRefuseUrl = "/refuse";

export const requestGetOfficeTransfer = createEffect({
  handler: restDetailsHandler<OfficeTransferDetail>(officeTransferUrl),
});

export const requestPostConfirmOfficeTransfer = createEffect({
  handler: restPostHandler<void, void>(
    officeTransferUrl,
    officeTransferConfirmUrl,
  ),
});

export const requestPostRefuseOfficeTransfer = createEffect({
  handler: restPostHandler<void, void>(
    officeTransferUrl,
    officeTransferRefuseUrl,
  ),
});
